'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppliedFiltersComponent = exports.defaultStyles = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral([''], ['']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouterDom = require('react-router-dom');

var _reactRouterRedux = require('react-router-redux');

var _FilterCollection = require('@bd/bdcore-data/build/Filters/FilterCollection');

var _actions = require('@bd/bdcore-data/build/Filters/actions');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreNamedRoutes2 = _interopRequireDefault(_bdcoreNamedRoutes);

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

var AppliedFiltersComponent = exports.AppliedFiltersComponent = function (_React$Component) {
  _inherits(AppliedFiltersComponent, _React$Component);

  function AppliedFiltersComponent(props) {
    _classCallCheck(this, AppliedFiltersComponent);

    var _this = _possibleConstructorReturn(this, (AppliedFiltersComponent.__proto__ || Object.getPrototypeOf(AppliedFiltersComponent)).call(this, props));

    _this.removeFilter = function (filter, filtervalue) {
      return function (event) {
        if (event.which && ![13, 32].includes(event.which)) {
          return;
        }

        var _this$props = _this.props,
            filters = _this$props.filters,
            keepParams = _this$props.keepParams,
            match = _this$props.match,
            pushUrl = _this$props.pushUrl,
            type = _this$props.type;

        var values = filters[filter].filter(function (value) {
          return value !== filtervalue;
        });
        var filterSettings = _lodash2.default.get((0, _FilterCollection.getFilters)(type), filter, {});

        if (!keepParams && filterSettings.routeParam) {
          var routeParam = filterSettings.routeParam;

          var _RouteCollection$getR = _bdcoreNamedRoutes2.default.getRouteByPath(match.path),
              pathName = _RouteCollection$getR.name;

          var _$get = _lodash2.default.get(match, 'params', {}),
              param = _$get[routeParam],
              matchParams = _objectWithoutProperties(_$get, [routeParam]);

          if (filterSettings.child) {
            // Clear child filter routeParam if configured
            var _$get2 = _lodash2.default.get((0, _FilterCollection.getFilters)(type), filterSettings.child, {}),
                childRouteParam = _$get2.routeParam;

            if (childRouteParam && _lodash2.default.has(matchParams, childRouteParam)) {
              delete matchParams[childRouteParam];
            }
          }

          var urlParams = new URLSearchParams(window.location.search);
          var urlFilters = JSON.parse(urlParams.get('filters') || '{}');

          var urlFilterValues = (values || []).map(function (v) {
            return v.label;
          });

          if (!urlFilterValues.length && filters[filter]) {
            delete urlFilters[filter];
          } else if (urlFilterValues.length) {
            urlFilters[filter] = urlFilterValues;
          }

          if (!Object.keys(urlFilters).length) {
            urlParams.delete('filters');
          } else {
            urlParams.set('filters', JSON.stringify(urlFilters));
          }

          var url = _bdcoreNamedRoutes2.default.getPath(pathName, matchParams);
          pushUrl(url + '?' + urlParams.toString());
        }

        _this.props.setFilter(filter, values.length ? values : null);
      };
    };

    _this.state = {};

    _this.clearFilters = _this.clearFilters.bind(_this);
    return _this;
  }

  _createClass(AppliedFiltersComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          clearOnLoad = _props.clearOnLoad,
          resetFilters = _props.resetFilters;


      if (clearOnLoad) {
        resetFilters();
      }
    }
  }, {
    key: 'clearFilters',
    value: function clearFilters() {
      var _props2 = this.props,
          filterOptions = _props2.filterOptions,
          filters = _props2.filters,
          keepParams = _props2.keepParams,
          match = _props2.match,
          pushUrl = _props2.pushUrl,
          resetFilters = _props2.resetFilters,
          type = _props2.type;


      if (!keepParams) {
        var _RouteCollection$getR2 = _bdcoreNamedRoutes2.default.getRouteByPath(match.path),
            pathName = _RouteCollection$getR2.name;

        var matchParams = _lodash2.default.get(match, 'params', {});
        var appliedFilterKeys = filterOptions.length > 0 ? _lodash2.default.intersection(_lodash2.default.map(filterOptions, 'filter'), Object.keys(filters)) : Object.keys(filters);

        appliedFilterKeys.forEach(function (filter) {
          var filterSettings = _lodash2.default.get((0, _FilterCollection.getFilters)(type), filter, {});
          if (filterSettings.routeParam) {
            var routeParam = filterSettings.routeParam;

            delete matchParams[routeParam];

            if (filterSettings.child) {
              // Clear child filter routeParam if configured
              var _$get3 = _lodash2.default.get((0, _FilterCollection.getFilters)(type), filterSettings.child, {}),
                  childRouteParam = _$get3.routeParam;

              if (childRouteParam && _lodash2.default.has(matchParams, childRouteParam)) {
                delete matchParams[childRouteParam];
              }
            }
          }
        });

        var urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('filters');
        var url = _bdcoreNamedRoutes2.default.getPath(pathName, matchParams);
        pushUrl(url + '?' + urlParams.toString());
      }

      resetFilters();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          className = _props3.className,
          clearButton = _props3.clearButton,
          filterOptions = _props3.filterOptions,
          filters = _props3.filters;

      var appliedFilterKeys = filterOptions.length > 0 ? _lodash2.default.intersection(_lodash2.default.map(filterOptions, 'filter'), Object.keys(filters)) : Object.keys(filters);

      if (!appliedFilterKeys.length) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'ul',
          { className: 'AppliedFilters_list' },
          appliedFilterKeys.map(function (filter) {
            return (filters[filter] || []).map(function (filterValue) {
              return _react2.default.createElement(
                'li',
                { key: filterValue.label, className: 'AppliedFilters_listItem' },
                _react2.default.createElement(
                  'span',
                  {
                    role: 'button',
                    tabIndex: '0',
                    className: 'AppliedFilters_listItemButton',
                    onClick: _this2.removeFilter(filter, filterValue),
                    onKeyDown: _this2.removeFilter(filter, filterValue),
                    'data-menuTogglerIgnore': true
                  },
                  filterValue.activeLabel || filterValue.label
                )
              );
            });
          })
        ),
        _react2.default.createElement(
          'span',
          {
            role: 'button',
            tabIndex: '0',
            className: 'AppliedFilters_clearButton',
            onClick: this.clearFilters
          },
          clearButton
        )
      );
    }
  }]);

  return AppliedFiltersComponent;
}(_react2.default.Component);

AppliedFiltersComponent.propTypes = {
  className: _propTypes2.default.string,
  /** Element to display as the clear button  */
  clearButton: _propTypes2.default.node,
  /** Clear all filters on component mount? */
  clearOnLoad: _propTypes2.default.bool,
  /** Filters config, used to limit applied filter display */
  filterOptions: _propTypes2.default.arrayOf(_propTypes2.default.object),
  /** Ignore: Given by redux */
  filters: _propTypes2.default.object,
  keepParams: _propTypes2.default.bool,
  /** Ignore: Given by redux */
  match: _propTypes2.default.object.isRequired,
  /** Ignore: Given by redux */
  pushUrl: _propTypes2.default.func.isRequired,
  /** Ignore: Given by redux */
  resetFilters: _propTypes2.default.func.isRequired,
  /** Ignore: Given by redux */
  setFilter: _propTypes2.default.func.isRequired,
  /** Filter type */
  type: _propTypes2.default.string.isRequired
};
AppliedFiltersComponent.defaultProps = {
  className: undefined,
  clearButton: _react2.default.createElement(
    'span',
    null,
    'Clear Filters X'
  ),
  clearOnLoad: false,
  filterOptions: [],
  filters: [],
  keepParams: false
};

function mapStateToProps(_ref) {
  var filters = _ref.filters;

  return {
    filters: filters
  };
}

function mapDispatchToProps(dispatch) {
  return {
    pushUrl: function pushUrl(url) {
      return dispatch((0, _reactRouterRedux.push)(url));
    },
    resetFilters: function resetFilters() {
      return dispatch((0, _actions.clearFilters)());
    },
    setFilter: function setFilter(name, values) {
      return dispatch((0, _actions.setFilter)(name, values));
    }
  };
}

var StyledAppliedFilters = (0, _bduiStyles2.default)(defaultStyles)((0, _reactRouterDom.withRouter)(AppliedFiltersComponent));
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(StyledAppliedFilters);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-appliedfilters/build/AppliedFilters.js
// module id = 1203
// module chunks = 0